@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.schoolLicensesListContainer {
  padding: variables.$std-padding-xlg;
  border-bottom: 1px solid #ddd;
}

.schoolDetailContainer {
  display: flex;
}

.schoolNameText {
  font-size: 1.6em;
  flex-basis: 30%;
}

.licenseDisclaimerText {
  font-size: 1.1em;
  margin-right: variables.$std-margin-md;
  font-style: italic;
  display: flex;
  align-items: center;
  color: variables.$gray-base;
}

.schoolActionsContainer {
  display: flex;
  justify-content: flex-end;
  flex-basis: 70%;
}

.licenseRowsContainer {
  margin-top: variables.$std-margin-sm;
  margin-bottom: variables.$std-margin-lg;
}

.schoolCourseSubjectsByLicensingToggleLabel {
  display: inline-block;
  color: variables.$theme-primary;
}
